import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import moment from 'moment-timezone'
import {
  Button,
  surveyType,
  useErrorService,
  useUserService,
} from '@abroad/components'
import API from '../../utils/API'
import { openLinkInTab } from '../../utils/openLinkInTab'
import { sortedByDate } from '../../utils/date'

const AssessmentTakenModal = ({ isShowModal, onClose }) => {
  const [isLoading, setIsLoading] = useState(false)
  const Error = useErrorService()
  const history = useHistory()
  const { user } = useUserService()

  const getUrl = async () => {
    try {
      setIsLoading(true)
      if (user?.prosperityTaken) {
        const { data } = await API.survey.getSurveys(
          'personal',
          surveyType.PROSPERITY,
        )
        if (data?.surveys?.length > 0) {
          const latestSurvey = sortedByDate(data.surveys, 'createdAt')[0]
          const isWithin24Hours =
            moment().diff(moment(latestSurvey?.createdAt), 'days') < 1
          if (isWithin24Hours) {
            onClose()
            history.push(`/prosperity/${latestSurvey._id}`)
            setIsLoading(false)
            return
          }
        }
      }
      const { data } = await API.survey.getLink(surveyType.PROSPERITY)
      setIsLoading(false)
      if (data?.code === 'upgrade_plan') {
        Error.showError(data)
      } else {
        openLinkInTab(data?.link, '_self')
      }
      onClose()
    } catch (e) {
      Error.showError(e)
      setIsLoading(false)
    }
  }

  return (
    <Modal
      show={isShowModal}
      onHide={onClose}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog  justify-content-center'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          ASSESSMENT SELECTION
        </h3>
      </Modal.Header>
      <Modal.Body>
        <div className='s7 text-start'>
          The Awareness Assessment is designed specifically for people in
          operating roles. Since you're currently in a career transition, we
          recommend taking the True Prosperity Assessment instead. This will
          ensure you get the most relevant and helpful analysis for your current
          situation.
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-center flex-row pt-0'>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          disabled={isLoading}
          // isLoading={isLoading}
          onClick={() => getUrl()}>
          Take True Prosperity Assessment
        </Button>
        <Button
          variant='secondary-light'
          className='custom-padding text-uppercase secondary-popup-button'
          size='sm'
          disabled={isLoading}
          onClick={onClose}>
          Maybe Later
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AssessmentTakenModal
